import axios from "axios";

const api = axios.create({
  baseURL: "https://api.bomarzodesign.com.br/api",
  // baseURL: "http://localhost:3001/api",
});

export default api;
